export default __webpack_public_path__ + "static/media/Physicians Mutual dark.ace2fe10.svg";